// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/shared/ImagePreviewField.module.css';
import type React from 'react';
export interface ImagePreviewFieldProps {
	imageUrl: string | null | undefined;
	showPlaceholder: boolean;
	placeholderText: React.ReactNode;
	altText: string;
	aspectRatio?: string | number;
	className?: string;
	objectFit?: 'cover' | 'contain';
}
export const ImagePreviewField: React.FC<ImagePreviewFieldProps> = ({
	imageUrl,
	showPlaceholder,
	placeholderText,
	altText,
	aspectRatio,
	className,
	objectFit = 'cover',
}) => {
	const innerContainerStyle: React.CSSProperties = aspectRatio
		? {
				position: 'relative',
				width: '100%',
				paddingBottom: `${(1 / Number(aspectRatio)) * 100}%`,
			}
		: {};
	const imageContainerStyle: React.CSSProperties = aspectRatio
		? {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
			}
		: {};
	const imageStyle: React.CSSProperties = {
		objectFit,
		width: '100%',
		height: '100%',
	};
	if (showPlaceholder || !imageUrl) {
		return (
			<div className={`${styles.placeholder} ${className ?? ''}`} style={aspectRatio ? innerContainerStyle : {}}>
				{aspectRatio ? (
					<div style={imageContainerStyle}>
						<span>{placeholderText}</span>
					</div>
				) : (
					<span>{placeholderText}</span>
				)}
			</div>
		);
	}
	return (
		<div className={`${styles.preview} ${className ?? ''}`} style={aspectRatio ? innerContainerStyle : {}}>
			{aspectRatio ? (
				<div style={imageContainerStyle}>
					<img src={imageUrl} alt={altText} className={styles.image} style={imageStyle} />
				</div>
			) : (
				<img src={imageUrl} alt={altText} className={styles.image} style={imageStyle} />
			)}
		</div>
	);
};
